import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import {
  Integration,
  InvocationBody,
  InvocationResponse,
} from "@pages/settings/types";

export const invokeIntegration = (
  deploymentId: string,
  integration: Integration,
  issueId: number
) => {
  return authPost<InvocationBody, InvocationResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integration.id}/invocation`,
    { issue_id: issueId }
  );
};
